<div class="icon">
  <ng-container *ngIf="evalPoint?.passed; else elseBlock">
    <svg style="border-radius: 3px; background-color: rgb(34, 197, 94)" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check white">
      <path d="M20 6 9 17l-5-5"></path>
    </svg>
  </ng-container>
  <ng-template #elseBlock>
    <svg style="border-radius: 3px; background-color: rgb(239, 68, 68)" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x white">
      <path d="M18 6 6 18"></path>
      <path d="m6 6 12 12"></path>
    </svg>
  </ng-template>
</div>
<div [ngClass]="{'header': header}" [style]="{'font-size': print ? '14px' : 'auto'}">{{ evalPoint?.criterion }}</div>
